// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1sAIp","footer":"ModalCreateQualiphyProcedure_footer__1OcGe","additionData":"ModalCreateQualiphyProcedure_additionData__3USQ1"};